import {
  Box,
  FormControl,
  InputLabel,
  makeStyles,
  OutlinedInput,
} from '@material-ui/core';
import { DateTime } from 'luxon';

const useStyles = makeStyles((theme) => ({
  container: {
    display: 'flex',
    flexWrap: 'wrap',
  },
  outlinedInput: {
    width: theme.spacing(30),
    height: theme.spacing(9),
  },
}));

type Props = {
  label: string;
  disabled?: boolean;
  defaultValue?: DateTime | null;
  onChange?: (dateTime: DateTime | null) => void;
  min?: DateTime | null;
  max?: DateTime | null;
};

DatePicker.defaultProps = {
  disabled: false,
};

/**
 * 日付ピッカー
 */
export default function DatePicker(props: Props): JSX.Element {
  const classes = useStyles();

  // eslint-disable-next-line @typescript-eslint/ban-types
  function onChanged(event: Object) {
    // @ts-ignore
    const dateStr = event.target.value;

    props.onChange &&
      props.onChange(dateStr ? DateTime.fromISO(dateStr) : null);
  }

  return (
    <Box display="inline">
      <FormControl
        className={classes.container}
        margin="dense"
        disabled={props.disabled}>
        <InputLabel id="date-label" variant="outlined" htmlFor="date">
          {props.label}
        </InputLabel>
        <OutlinedInput
          id="date"
          className={classes.outlinedInput}
          type="date"
          defaultValue={
            props.defaultValue ? props.defaultValue.toISODate() : ''
          }
          label="date-label"
          inputProps={{
            min: props.min && props.min.toISODate(),
            max: props.max && props.max.toISODate(),
          }}
          onChange={onChanged}
        />
      </FormControl>
    </Box>
  );
}
